import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import type {ChartEventViewModel} from "../../../domain/full-game/models/chart-events/event/chart-event.view-model";
import type {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import type {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {GAME_SHOT_CHARTS} from "../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {runInAction} from 'mobx';

export class CompetitorPlayerStatsModuleShotSelectedHandler extends ActionHandler {
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      if(params.shot?.key) {
        this.setSelectedShot(params);
        this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.shotMapShotClick, {
          athleteId: this.state.selectedPlayer.athleteId,
          gameId: this.state.game.id,
          status: this.state.game.statusGroup,
          outcome: params.shot.outcomeAnalyticValue
        })
      } else {
        this.setByDirection(params);
      }
    })


  }

  setSelectedShot(params) {
    this.state.selectedPlayer.selectedShotKey = params.shot.key;
    params.isOnShotClick && this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onGoalViewExpanded, {isVisible: true})
  }

  setByDirection(params) {
    if (params?.direction) {
      const context: Array<ChartEventViewModel> = this.state.selectedPlayer.shots;
      let index: Number = context.findIndex(shot => shot.key === this.state.selectedPlayer.selectedShotKey);

      if (params.direction === GAME_SHOT_CHARTS.DIRECTIONS.prev) {
        index = index === 0 ? context.length - 1 : index - 1;
      } else if (params.direction === GAME_SHOT_CHARTS.DIRECTIONS.next) {
        index = index === context.length - 1 ? 0 : index + 1;
      }

      this.state.selectedPlayer.selectedShotKey = context[index]?.key;

      this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.shotMapShotSwipeClick, {
        athleteId: this.state.selectedPlayer.athleteId,
        gameId: this.state.game.id,
        status: this.state.game.statusGroup,
        outcome: context[index].outcomeAnalyticValue
      })
    } else {
      this.state.selectedPlayer.selectedShotKey = null
    }
  }
}
